export default function(selector) {

    // Create a callback function that will be triggered when the intersection occurs
    const callback = (entries, observer) => {
        entries.forEach(entry => {
            const delay = entry.target.dataset.delay || 0;
            if (entry.intersectionRatio >= 0.2) { // 20% of the element is in the viewport
                if (delay > 0) {
                    setTimeout(() => {
                        entry.target.classList.add('animation-fade-from-bottom');
                        entry.target.style.opacity = '';
                    }, delay);
                    return;
                }
                entry.target.classList.add('animation-fade-from-bottom');
                entry.target.style.opacity = '';
            }
        });
    };

    // Create an IntersectionObserver instance with a threshold of 20%
    const options = {
        threshold: 0.2
    };
    const observer = new IntersectionObserver(callback, options);

    // Select the elements you want to observe and hide them
    const targetElement = document.querySelectorAll(selector);
    targetElement.forEach(element => {
        element.style.opacity = '0';
        observer.observe(element);
    });

}